import React, { useState } from "react";
import loginBg from "../../asset/login bg.png";
import logo from "../../asset/logo.svg";
import { FaLock } from "react-icons/fa6";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useResetPasswordMutation } from "../../redux/userApi";
import ButtonLoading from "../../Component/Button loading/ButtonLoading";
import { showErrorToast } from "../../utils/Utils";

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState({
    password: "",
    confirmPassword: "",
  });

  const { token } = useParams();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.password) {
      newErrors.password = "Password is required.";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters.";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required.";
    } else if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setError(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    if (!token) {
      toast.error("Reset token is missing");
      return;
    }

    try {
      let response = null;
      response = await resetPassword({
        resetToken: token,
        password: formData.password,
      }).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      showErrorToast(err);
    }
  };
  return (
    <div className=" w-full h-screen relative">
      <img src={loginBg} className="w-full h-full  object-fill" alt="" />
      <div className=" absolute h-screen bg-white p-8 2xl:w-[35%] xl:w-[38%] lg:w-[43%] md:w-[50%] sm:w-[65%] w-full top-0 right-0 sm:rounded-s-2xl flex flex-col gap-4 items-center justify-center">
        <img src={logo} className="w-28" alt="" />
        <span className="text-[1.8rem] text-[#333333] font-semibold">
          Welcome Back!
        </span>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 items-center justify-center w-[90%]"
        >
          <div className="flex flex-col gap-1 w-full">
            <div className="flex gap-3 w-full bg-transparent border p-3 rounded-full items-center text-[#33333390]">
              <FaLock className="size-6" />
              <input
                type="password"
                name="password"
                value={formData.password}
                placeholder="Password"
                onChange={handleChange}
                className="w-full bg-transparent outline-none rounded-none"
              />
            </div>
            {error.password && (
              <p className="text-sm text-red-500">{error.password}</p>
            )}
          </div>

          <div className="flex flex-col gap-1 w-full">
            <div className="flex gap-3 w-full bg-transparent border p-3 rounded-full items-center text-[#33333390]">
              <FaLock className="size-6" />
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                placeholder="Confirm Password"
                onChange={handleChange}
                className="w-full bg-transparent outline-none rounded-none"
              />
            </div>
            {error.confirmPassword && (
              <p className="text-sm text-red-500">{error.confirmPassword}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full mt-10 p-3 bg-[#00643b] rounded-full font-medium text-white flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <ButtonLoading text="Reset Password..." />
            ) : (
              "Reset Password"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
